import React from 'react'
import { useTranslation } from 'react-i18next'
import { MarketBars } from './MarketBars'

type SalesCardProps = {
    total: string
    markets: Array<{ code: string; widthPct: number; value: string }>
    currency: 'EUR' | 'USD'
    setCurrency: (currency: 'EUR' | 'USD') => void
}

export const SalesCard: React.FC<SalesCardProps> = ({ total, markets, currency, setCurrency }) => {
    const { t } = useTranslation('dashboard')
    return (
    <div className="bg-white rounded-2xl p-4 border border-neutralBlack-200 shadow-sm flex flex-col gap-1.5">
        <div className="flex items-center gap-2">
            <span className="flex-1 min-w-0 text-[11.5px] font-medium tracking-wide uppercase text-neutralBlack-500">{t('metrics.salesGenerated')}</span>
            <span className="flex gap-0.5 bg-neutralBlack-100 rounded-full p-0.5">
                {(['EUR', 'USD'] as const).map((c) => (
                    <button
                        type="button"
                        key={c}
                        onClick={() => setCurrency(c)}
                        className={`w-7 h-6 inline-flex items-center justify-center rounded-full text-[12.5px] font-semibold ${
                            currency === c ? 'bg-neutralBlack-900 text-white' : 'text-neutralBlack-600'
                        }`}
                    >
                        {c === 'EUR' ? '€' : '$'}
                    </button>
                ))}
            </span>
        </div>
        <span className="text-[26px] font-semibold tracking-tight text-neutralBlack-900">{total}</span>
        <span className="text-[12.5px] text-neutralBlack-600">{t('metrics.salesNote')}</span>
        {markets.length > 0 && <MarketBars items={markets} />}
    </div>
    )
}
